/**
 * Created by Yangxunwu on 2018/6/21.
 */
import { loginByPhone, loginBySms, logout, getUserInfo } from '@/api/login'
import { register, finishRegister } from "@/api/register"
import { getToken, setToken, removeToken, setFinishRegister, getFinishRegister, removeFinishRegister, setUserType } from '@/utils/auth'
import { ssoLogging } from "@/api/qywx"

const user = {
	state: {
		phone: '',
		email: '',
		name: '',
		token: getToken(),
        finishRegister: false,
		corpName: "",
		type: null,
	},

	mutations: {

		SET_PHONE: (state, phone) => {
			state.phone = phone
		},

		SET_NAME: (state, name) => {
			state.name = name
		},

		SET_EMAIL: (state, email) => {
			state.email = email;
		},

		SET_TOKEN: (state, token) => {
            state.token = token
		},

        FINISH_REGISTER:(state, finishRegister) => {
			state.finishRegister = finishRegister;
		},

		SET_TYPE: (state, type) => {
			state.type = type
		},

	},

	actions: {

		Register({ commit }, registerInfo) {

			return new Promise((resolve, reject) => {

				register(registerInfo.phone, registerInfo.smsCode).then(response => {

					const data = response.data;

					commit('SET_TOKEN', data.user.access_token)
					commit('SET_NAME', data.user.name);
					commit('SET_PHONE', data.user.phone);
					commit('SET_EMAIL', data.user.email);
                    commit("FINISH_REGISTER", data.user.finishRegister)
                    commit("SET_TYPE", data.user.type)

					setUserType(data.user.type);
					setToken(response.data.user.access_token)
					setFinishRegister(data.user.finishRegister);

					resolve(response)
				}).catch(error => {
					reject(error);
				})

			})
		},

        /**
		 * 完善注册信息
         * @param commit
         * @param registerInfo
         * @returns {Promise<any>}
         * @constructor
         */
		FinishRegister({ commit }, registerInfo) {

			console.log(registerInfo);
			return new Promise((resolve, reject) => {

                finishRegister(registerInfo.password, registerInfo.corpName, registerInfo.userName).then(response => {

                	const data = response.data;

                	commit("SET_NAME", data.user.name);
                	commit("FINISH_REGISTER", data.user.finishRegister)

	                setFinishRegister(data.user.finishRegister);

                	resolve(response);
				}).catch(error => {
					reject(error);
				})
			})
		},

		/**
		 * 手机号码登录
		 * @param commit
		 * @param userInfo
		 * @returns {Promise}
		 * @constructor
		 */
		LoginByPhone({ commit }, userInfo) {

			console.log(userInfo);

			return new Promise((resolve, reject) => {

				loginByPhone(userInfo.phone.trim(), userInfo.password).then(response => {

					let data = response.data;

					commit('SET_TOKEN', data.user.access_token)
					commit('SET_NAME', data.user.name);
					commit('SET_PHONE', data.user.phone);
					commit('SET_EMAIL', data.user.email);
                    commit("FINISH_REGISTER", data.user.finishRegister)
					commit("SET_TYPE", data.user.type)

					setUserType(data.user.type);
					setToken(response.data.user.access_token)
					setFinishRegister(data.user.finishRegister);

					resolve(response)

				}).catch(error => {
					reject(error)
				})
			})
		},

		/**
		 * 短信验证码登录
		 * @param commit
		 * @param loginInfo
		 * @returns {Promise}
		 * @constructor
		 */
		LoginBySms({ commit }, loginInfo) {

            console.log(loginInfo);

			return new Promise((resolve, reject) => {

				loginBySms(loginInfo.phone.trim(), loginInfo.smsCode).then(response => {

					const data = response.data

					commit('SET_TOKEN', data.user.access_token)
					commit('SET_NAME', data.user.name);
					commit('SET_PHONE', data.user.phone);
					commit('SET_EMAIL', data.user.email);
                    commit("FINISH_REGISTER", data.user.finishRegister)
					commit("SET_TYPE", data.user.type)

					setUserType(data.user.type);
					setToken(response.data.user.access_token)
					setFinishRegister(data.user.finishRegister);

					resolve(response)

				}).catch(error => {
					reject(error)
				})
			})
		},

		/**
		 * 获取用户信息
		 * @param commit
		 * @param state
		 * @returns {Promise}
		 * @constructor
		 */
		GetUserInfo({ commit, state }) {

			return new Promise((resolve, reject) => {

				getUserInfo(state.token).then(response => {

					const data = response.data

					commit('SET_TOKEN', data.user.access_token)
					commit('SET_NAME', data.user.name);
					commit('SET_PHONE', data.user.phone);
					commit('SET_EMAIL', data.user.email);
                    commit("FINISH_REGISTER", data.user.finishRegister)
					commit("SET_TYPE", data.user.type)

					setUserType(data.user.type);
					setToken(response.data.user.access_token)
					setFinishRegister(data.user.finishRegister);

					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 登出
		LogOut({ commit }) {

			return new Promise((resolve, reject) => {
				logout().then((response) => {
					commit('SET_TOKEN', '')
					removeToken()
					removeFinishRegister()
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

		//企业微信单点登陆
		QywxSsoLogin({ commit }, ssoInfo) {
            return new Promise((resolve, reject) => {

            	console.log('企业微信单点登陆:' + JSON.stringify(ssoInfo));
            	if(ssoInfo.authCode) {
                    ssoLogging(ssoInfo.authCode).then((response) => {

                        console.log('单点登陆响应' + JSON.stringify(response));

                        if(response.data.status === 1) {
                            commit('SET_TOKEN', response.data.token)

                            setToken(response.data.token)
                            resolve(response)
                        }else{
                            reject(response.data.failedReason)
                        }
                    }).catch(error => {
                        reject(error)
                    })
				}else{
            		reject("缺少授权码");
				}
            })
		}
	}
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js